import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { RouterOutlet } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'emp-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  private document = inject(DOCUMENT);
  private themeService = inject(ThemeService);

  private rootElement = this.document.documentElement;
  private theme$ = toObservable(this.themeService.theme);
  private isFirstRender = true;

  ngOnInit(): void {
    this.observeThemeChange();
  }

  private observeThemeChange() {
    this.theme$.subscribe(theme => {
      if (this.isFirstRender) {
        this.rootElement.setAttribute('data-theme', theme);
        this.isFirstRender = false;
        return;
      }
      this.document.startViewTransition(() => {
        this.rootElement.setAttribute('data-theme', theme);
      });
    });
  }
}
